import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Idioma } from '../../models/idioma';
import { forEach } from '@angular/router/src/utils/collection';

@Pipe({
    name: 'filtroTipoDeVenta' // nombre del pipe en las directivas
})

export class FiltrarConfirmaciones implements PipeTransform{
    // Recibe un arreglo de servicios una hora inicial y una final
    transform(confirmaciones:Array<any>,visible:boolean){
        let nuevoArreglo=[];
        if(confirmaciones){
            if(visible){
                confirmaciones.forEach(conf=>{
                    if(conf.tipoDeVenta == 'Corporativo' || conf.tipoDeVenta == 'Escolar')
                     nuevoArreglo.push(conf)
                })
            }else{
            confirmaciones.forEach(conf=>{
                if(conf.tipoDeVenta != 'Corporativo' && conf.tipoDeVenta != 'Escolar')
                    nuevoArreglo.push(conf)
            })
            }
        }
      return nuevoArreglo;
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtrar-confirmaciones-por-TipoVenta.pipe.ts